class Totop {
    constructor() {
        const btn = document.getElementById('totop')

        if (btn) {

            if (window.pageYOffset > 300) {
                btn.classList.remove('totop--hidden')
            }

            btn.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' 
                });
            })
            window.addEventListener('scroll', this.showButton)
        }
    }

    showButton() {
        const btn = document.getElementById('totop')
        if (window.pageYOffset > 300) {
            btn.classList.remove('totop--hidden')
        } else {
            btn.classList.add('totop--hidden')
        }
    }
}

export default Totop